import axios, { AxiosStatic } from "axios";

import { CurrentUser } from "./model";

const apiUrl = "/api/profile";

export class CurrentUserApi {
    private axios: AxiosStatic;

    constructor(ax: AxiosStatic) {
        this.axios = ax;
    }

    public async get(): Promise<CurrentUser> {
        const response = await this.axios.get<CurrentUser>(apiUrl);
        return response.data;
    }

    public async changeCompanyContext(companyId: string): Promise<CurrentUser> {
        const config = {
            headers: {
                Customer_Id: undefined as string
            }
        };
        const response = await this.axios.post<CurrentUser>(`${apiUrl}/${companyId}`, null, config);
        return response.data;
    }

    public async updateTermsAccepted(): Promise<CurrentUser> {
        const response = await this.axios.post<CurrentUser>(`${apiUrl}/UpdateTermsAccepted`);
        return response.data;
    }
}

export default new CurrentUserApi(axios);
